import * as getters from "./search.getters";
import * as actions from "./search.actions";
import * as mutations from "./search.mutations";

const state = {
    isWaypointLimitReached: false,
    waypointPositions: {
        start: false,
        interim: false,
        end: false,
    },
    searchId: 0,
    lastSearches: [],
    lastRoutes: [],
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}